import { FC } from 'react';

import { useScreenSize, useSelectedCompany } from '../../hooks/index';
import { PendingOperationsPill } from './components/pending-operations-pill';
import { EventsDesktop } from './desktop/index';
import { useEventsSecondaryQueriesEnabled } from './hooks/use-events-secondary-queries-enabled.hook';
import { EventsMobile } from './mobile/events-mobile';
import { EventsMobileHistory } from './mobile/events-mobile-history';

const Events: FC = () => {
  const { isMobile } = useScreenSize();
  const { selectedCompany } = useSelectedCompany();
  const companyId = selectedCompany?.id || '';
  const secondaryQueriesEnabled = useEventsSecondaryQueriesEnabled(companyId);

  return (
    <>
      {isMobile ? (
        <div className="flex w-full flex-col gap-4 p-[1px]">
          <EventsMobile companyId={companyId} secondaryQueriesEnabled={secondaryQueriesEnabled} />
          <EventsMobileHistory companyId={companyId} />
        </div>
      ) : (
        <EventsDesktop companyId={companyId} />
      )}
      <PendingOperationsPill companyId={companyId} />
    </>
  );
};
export default Events;
